// ABOUTME: Authenticated route shell - AuthGate + context providers + Layout + Outlet
// ABOUTME: Suspense wraps just the Outlet so lazy page loads don't unmount the shell or providers

import { ConfirmDialogProvider } from '@boundarylab/ui';
import { useQueryClient } from '@tanstack/react-query';
import { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { KeyboardShortcutsProvider } from '../contexts/KeyboardShortcutsContext';
import { PortfolioProvider } from '../contexts/PortfolioContext';
import { RebalanceQueueProvider } from '../contexts/RebalanceQueueContext';
import { SymbolSourceProvider } from '../contexts/SymbolSourceContext';
import { pageTitle } from '../lib/page-title';
import { startRoutePrefetch } from '../lib/route-prefetch';
import { AuthGate } from './AuthGate';
import { Layout } from './Layout';
import { RouteLoader } from './RouteLoader';

export function AuthShell() {
  const queryClient = useQueryClient();
  useEffect(() => {
    void startRoutePrefetch(queryClient, window.location.pathname);
  }, [queryClient]);

  const { pathname } = useLocation();
  useEffect(() => {
    document.title = pageTitle(pathname);
  }, [pathname]);

  return (
    <AuthGate>
      <PortfolioProvider>
        <SymbolSourceProvider>
          <RebalanceQueueProvider>
            <KeyboardShortcutsProvider>
              <ConfirmDialogProvider>
                <Layout>
                  <Suspense fallback={<RouteLoader />}>
                    <Outlet />
                  </Suspense>
                </Layout>
              </ConfirmDialogProvider>
            </KeyboardShortcutsProvider>
          </RebalanceQueueProvider>
        </SymbolSourceProvider>
      </PortfolioProvider>
    </AuthGate>
  );
}
